import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import StyledBrowserList from 'components/organisms/Browsers/BrowserList/BrowserList.styles';
import Browser from 'components/organisms/Browsers/Browser/Browser';
import Debounce from 'components/organisms/Utils/Debounce/Debounce';
import constants from 'helpers/constants';

const BrowserList = React.forwardRef((props, ref) => {
  const {
    items,
    selectedId,
    BrowserProps,
    ...innerProps
  } = useComponentProps({
    showControls: false,
    color: 'primary',
    ...props
  }, 'BrowserList');

  const selectedIndex = items.findIndex((item) => selectedId === item.id);

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledBrowserList ref={ref} {...innerProps}>
    {items.map((item, idx) => {
      return <Debounce key={item.id}
                       frames={idx === selectedIndex ? 1 : 0}
                       timeout={idx !== selectedIndex ? (Math.abs(selectedIndex - idx) * constants.debounce.browser) : 0}>
        <Browser url={item.url}
                 screenshots={item.screenshots}
                 className={`BrowserList-browser ${selectedId === item.id ? 'visible' : ''}`}
                 {...BrowserProps}/>
      </Debounce>
    })}
  </StyledBrowserList>
});

BrowserList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  items: PropTypes.array,
  selected: PropTypes.object,
  BrowserProps: PropTypes.object
};

export default BrowserList;
